const Footer = () => {
  const revision =
    typeof __GIT_REVISION__ !== "undefined" ? __GIT_REVISION__ : "development";

  return (
    <footer className="footer sm:footer-horizontal footer-center bg-base-200 text-base-content/50 p-4">
      <aside>
        <span className="font-mono">rev: {revision}</span>
      </aside>
    </footer>
  );
};

export default Footer;
